import $ from 'jquery';
import Lunr from 'lunr';
import debounce from 'lodash/debounce';

type PageSummary = { id: string, href: string, title: string };
type IndexJson = {
    pages: PageSummary[];
    /** serialized Lunr.Index */
    idx: object;
};
const indexes: Record<string, {
    pages: PageSummary[];
    lunr: Lunr.Index;
}> = {};

window.addEventListener('load', initLunr);
function initLunr() {
    $('[data-lunr-search]').each((idx, elem) => {
        const el = elem as HTMLInputElement;
        const indexName = el.dataset.lunrSearch!;
        $(el).addClass('loading');
        el.disabled = true;
        $.getJSON(`/assets/lunr/${indexName}.json`).then((data: IndexJson) => {
            // console.log(`Loaded index ${indexName}`, { pages: data.pages });
            indexes[indexName] = {
                pages: data.pages,
                lunr: Lunr.Index.load(data.idx),
            };
            $(el).removeClass('loading');
            el.disabled = false;
            if (el.value) {
                handleSearchInput({target: el} as any);
            }
        });
    });
    $('[data-lunr-search]').on('input', debounce(handleSearchInput, 150));
}

function handleSearchInput(evt: JQuery.TriggeredEvent) {
    const el = evt.target as HTMLInputElement;
    const searchStr = el.value;
    const resultsEl = document.querySelector(el.dataset.lunrResults!) as HTMLElement;
    const noResultsEl = document.querySelector(el.dataset.lunrNoResults!) as HTMLElement;
    const indexName = el.dataset.lunrSearch!;
    if (!indexes[indexName]?.pages || !indexes[indexName]?.lunr || !resultsEl || !noResultsEl) {
        return;
    }
    resultsEl.innerHTML = '';
    if (!searchStr) {
        resultsEl.classList.add('d-none')
        noResultsEl.classList.add('d-none')
        return;
    }
    const { pages, lunr } = indexes[indexName];
    const words = el.value.split(/\s+/);
    // unfortunately, a wildcard at the end won't match the actual word... `orders*` doesn't match `orders@signalstuff.com`
    if (words.length === 1) {
        words.push(`${words[0]}*`);
    }

    const results = lunr.search(words.join(' '));
    if (!results.length) {
        resultsEl.classList.add('d-none')
        noResultsEl.classList.remove('d-none')
        return;
    } else {
        resultsEl.classList.remove('d-none')
        noResultsEl.classList.add('d-none')}
        results.forEach(result => addResult(pages, result, resultsEl));
}

function addResult(pages: PageSummary[], result: lunr.Index.Result, container: HTMLElement) {
    const data = pages.find(r => r.id === result.ref);
    if (!data) { return; }
    $(`<li data-aos="fade" data-aos-duration="200"><a href="${data.href}">${data.title}</a></li>`).appendTo(container);
}

